module.exports = __webpack_public_path__ + "static/media/blue@2x.09f3df43.png";